import * as api from './questionnaires-api';
import * as actions from './questionnaires-action-creator';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const loadQuestionnaires = (patientId) => (dispatch) =>
  api.getQuestionnaires(patientId)
    .then(
      (response) => dispatch(actions.questionnairesLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }

    );

export const loadNewQuestionnairesCount = (patientId) => (dispatch) =>
  api.getNewQuestionnairesCount(patientId)
    .then((response) =>
      dispatch(actions.newQuestionnairesCountLoaded(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
    );

export const loadQuestionnaireDetails = (patientId, questionnaireId) => (dispatch) =>
  api.getQuestionnaireDetails(patientId, questionnaireId)
    .then((response) =>
      dispatch(actions.questionnaireDetailsLoaded(response.data)),
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage(error.message));
    }
    );

export const submitQuestionnaire = (patientId, assignedQuestionnaire) => (dispatch) => {
  // The javascript date object returns has a gmt offset associated with it. We need to get rid of it because it
  // will return the date in UTC. We want local time here as the user wants the date they entered to be returned.
  if (assignedQuestionnaire.patientQuestionAnswerList) {
    assignedQuestionnaire.patientQuestionAnswerList.forEach(
      (answer) => {
        if (answer.dateAnswer) {
          answer.dateAnswer.setTime(
            answer.dateAnswer.getTime() - answer.dateAnswer.getTimezoneOffset() * 60 * 1000);
        }
      }
    );
  }
  return api.submitQuestionnaire(patientId, assignedQuestionnaire)
    .then(
      (response) => dispatch(actions.questionnaireSubmitted(response.data)),
      () => dispatch(MsgBarActions.showErrorMessage('questionnairesendfailed'))
    );
};

export const declineQuestionnaire = (patientId, questionnaireId) => (dispatch, getState) => {
  const questionnaire =
    getState().questionnaires.assignedQuestionnaires
      .find((q) => q.assignedQuestionnaireId === questionnaireId);
  return api.declineQuestionnaire(patientId, questionnaire).then(
    () => {
      dispatch(loadQuestionnaires(patientId));
      return dispatch(loadNewQuestionnairesCount(patientId));
    },
    () => dispatch(MsgBarActions.showErrorMessage('questionnairedeclinefailed'))
  );
};

export const validateQuestionnaire = (questionnaireId) => (dispatch, getStoredState) => {
  dispatch(actions.questionnaireValidated(questionnaireId));

  const validatedQuestionnaire =
    getStoredState().questionnaires.assignedQuestionnaires
      .find((q) => q.assignedQuestionnaireId === questionnaireId);

  return new Promise(
    (resolve, reject) => {
      if (validatedQuestionnaire !== undefined && validatedQuestionnaire.isValid !== undefined) {
        resolve(validatedQuestionnaire.isValid);
      } else {
        reject();
      }
    }
  );
};

export const loadHistoricalQuestionnaires = (patientId) => (dispatch) =>
  api.getHistoricalQuestionnaires(patientId)
    .then(
      (response) => dispatch(actions.historicalQuestionnairesLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadHistoricalQuestionnaireDetails = (patientId, questionnaireId) => (dispatch) =>
  api.getHistoricalQuestionnaireDetails(patientId, questionnaireId)
    .then(
      (response) => dispatch(actions.historicalQuestionnaireDetailsLoaded(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadKioskQuestionnaires = (dueDate, facility) => (dispatch) =>
  api.getKioskQuestionnaires(dueDate)
    .then(
      (response) => {
        dispatch(actions.kioskQuestionnairesLoaded(response.data));
        const facilityOptions = response.data;
        if (facility) {
          let facilityOption = 'all';
          if (facilityOptions && facilityOptions.length) {
            const found = facilityOptions.find((f) => f.facilityShortName === facility);
            if (found) {
              facilityOption = found.facilityShortName;
            }
          }
          dispatch(actions.kioskQuestionnairesFiltered(facilityOption));
        }
      },
      (axiosResponse) => {
        const error = axiosResponse.response;
        if (error.status === 400 && error.data === 'feature_inactive') {
          return dispatch(actions.kioskQuestionnairesLoaded(['feature_inactive']));
        }
        return dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );